import React, { useState, useEffect, useRef } from "react";

import Select from 'react-select';
import CompetitorRepository from '../../domain/repositories/CompetitorRepository';
import ParticipatesInRepository from '../../domain/repositories/ParticipatesInRepository';
import SectionRepository from '../../domain/repositories/SectionRepository';
import CertificateRepository from '../../domain/repositories/CertificateRepository';
import Certificate from '../../domain/models/CertificateModel';




import { API_ENDPOINT, TOKEN, ENDPOINT_CATEGORY_SESSION, ENDPOINT_ITEMS_SECTION } from '../../utils/constants';
import * as Constants from '../../utils/constants';

import '../../assets/css/table.css';
import { useNavigate } from 'react-router-dom';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file


function Competition() {

    const navigate = useNavigate();
 

    const [posts, setPosts] = useState([]);


    const [categoryOptions, setCategoryOptions] = useState([]);
    const [categorySelectedOptions, setCategorySelectedOptions] = useState([]);

    const [sessionOptions, setSessionOptions] = useState([]);
    const [sessionSelectedOptions, setSessionSelectedOptions] = useState([]);



    const [sectionOptions, setSectionOptions] = useState([]);
    const [sectionSelectedOptions, setSectionSelectedOptions] = useState([]);


    const [categorySessionId, setCategorySessionId] = useState('');


    const [competitorNameOptions, setCompetitorNameOptions] = useState([]);
    const [competitorNameSelectedOptions, setCompetitorsNameSelectedOptions] = useState([]);


    const [nameInputValue, setNameInputValue] = useState('');
    const [sectionInputValue, setSectionInpuValue] = useState('');


    const [competitionData, setCompetitionData] = useState([]);
    const [page, setPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(5);
    const [totalPages, setTotalPages] = useState(0);
    const [competitionTableFilter, setCompetitionTableFilter] = useState(false);

    const [errorMessage, setErrorMessage] = useState('');
    const [isError, setIsError] = useState(false);


    const [sendingEmail, setSendingEmail] = useState(false);
    const [isPrinting, setIsPrinting] = useState(false);


    const currentDate = new Date();
    const lastYearDate = new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate());


    const [startDate, setStartDate] = useState(lastYearDate.toISOString().split('T')[0]); // set to last year's date with today's month and year
    const [endDate, setEndDate] = useState(currentDate.toISOString().split('T')[0]); // set to today's date


    const [rankSelectedOption, setRankSelectedOption] = useState(1);
    const [rankOptions, setRankOptions] = useState([]);



    const [dateRange, setDateRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection'
    });

    const [showPicker, setShowPicker] = useState(false);




    const competitorRepository = new CompetitorRepository();
    const participatesInRepository = new ParticipatesInRepository();
    const sectionRepository = new SectionRepository();
    const certificateRepository = new CertificateRepository();


    const handleDateRangeChange = (ranges) => {
        setDateRange(ranges.selection);
        console.log("Date Range")
    };

    const handleDateRangeDoneClick = () => {
        setShowPicker(false);
        const startDate = dateRange.startDate.toLocaleDateString();
        const endDate = dateRange.endDate.toLocaleDateString();
        console.log('Start Date:', startDate);
        console.log('End Date:', endDate);
        setStartDate(startDate)
        setEndDate(endDate)

    };

    const handleDateRangeButtonClick = () => {
        setShowPicker(!showPicker);
    };

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
    };

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
    };

    const handleSearchClear = () => {
        // setCompetitionStartDate(null)
        // setCompetitionEndDate(null)
        setCategorySelectedOptions(null)
        setSessionSelectedOptions(null)
        setSectionSelectedOptions(null)
        setCompetitorsNameSelectedOptions(null);

    };



    const handleSectionSelectedOptions = sectionSelectedOptions => {
        setCompetitorsNameSelectedOptions(sectionSelectedOptions);
        console.log("Section ID:", sectionSelectedOptions.value)

        //fetch in participates table for call compeittion with competition id
        setCompetitionTableFilter(true)

    };


    const handleCompetitorsNameSelectedOptions = competitorNameSelectedOptions => {
        setCompetitorsNameSelectedOptions(competitorNameSelectedOptions);
        console.log("Competitors ID:", competitorNameSelectedOptions.value)

        //fetch in participates table for call compeittion with competition id
        setCompetitionTableFilter(true)

    };

    // const handleSectionSelectChange = sectionSelectedOptions => {
    //     setSectionSelectedOptions(sectionSelectedOptions);

    // };

    const handleSectionSelectChange = async (newSectionValue) => {
        setSectionOptions([]);

        setSectionInpuValue(newSectionValue);

        try {
            const sectionData = await sectionRepository.getAllSectionsWithFilter(newSectionValue);

            const newOptions = sectionData.map(item => ({
                value: item.sectionId,
                label: item.sectionCode + ' ' + item.sectionDesc,
            }));
            setSectionOptions(newOptions);


        } catch (error) {
            setSectionOptions([])
        }



    };

    const handleCategorySelectChange = categorySelectedOptions => {
        setCategorySelectedOptions(categorySelectedOptions);
        setCompetitionTableFilter(true)

    };

    const handleSessionSelectChange = sessionSelectedOptions => {

        setSessionSelectedOptions(sessionSelectedOptions);

        const headers = new Headers();
        headers.append('Authorization', `Bearer ${TOKEN}`);

        const categorySessionParams = { "session": { "_eq": sessionSelectedOptions.value }, "category": { "_eq": categorySelectedOptions.value } }

        var categorySessionFetchURL = API_ENDPOINT + ENDPOINT_CATEGORY_SESSION + '?filter=' + JSON.stringify(categorySessionParams)


        async function fetchCategorySession() {
            try {


                const categorySessionResponse = await fetch(categorySessionFetchURL, { headers });
                const cayegorySessionJsonData = await categorySessionResponse.json();
                if (cayegorySessionJsonData.data.length > 0) {
                    var categorySessionIdTemp = ''
                    cayegorySessionJsonData.data.map(categorySession => categorySessionIdTemp = categorySession.category_session_id)

                    setCategorySessionId(categorySessionIdTemp)

                    const categorySessionSectionParams = { "category_session": { "_eq": categorySessionIdTemp } }
                    var sectionFetchURL = API_ENDPOINT + ENDPOINT_ITEMS_SECTION + '?filter=' + JSON.stringify(categorySessionSectionParams)


                    const sectionResponse = await fetch(sectionFetchURL, { headers });
                    const sectionJsonData = await sectionResponse.json();
                    if (sectionJsonData.data.length > 0) {
                        setSectionOptions(sectionJsonData.data)

                    }

                }
                setCompetitionTableFilter(true)

            }
            catch (error) {
                setIsError(true)
                setErrorMessage("Error Selecting Session")
                console.error(error)
            }
        }

        // fetchCategorySession()


        // fetch(categorySessionFetchURL, { headers })
        //     .then((response) => response.json())
        //     .then((categorySessions) => {

        //         if (categorySessions.data.length > 0) {

        //             categorySessions.data.map(categorySession => categorySessionId = categorySession.category_session_id)
        //             const categorySessionSectionParams = { "category_session": { "_eq": categorySessionId } }
        //             var sectionFetchURL = API_ENDPOINT + ENDPOINT_ITEMS_SECTION + '?filter=' + JSON.stringify(categorySessionSectionParams)
        //             return fetch(sectionFetchURL, { headers })
        //         }
        //     })
        //     .then(response =>
        //         response.json()

        //         // console.log(response.json())
        //     )

        //     .then(sectionData => {
        //         // console.log(sectionData)
        //         if (sectionData.data.length > 0) {
        //             setSectionOptions(sectionData.data)
        //         }
        //     })
        //     .catch(error => console.error(error));

    }


    const handleNameChange = async (newValue) => {
        setCompetitorNameOptions([]);


        setNameInputValue(newValue);


        if (newValue.length > 0) {

            try {
                const competitorData = await competitorRepository.getAllCompetitorsWithName(newValue)

                const newOptions = competitorData.map(item => ({
                    value: item.competitorId,
                    label: item.competitorFirstName + ' ' + item.competitorLastName,
                }));
                setCompetitorNameOptions(newOptions);


            } catch (error) {
                setCompetitorNameOptions([])
            }

        }
        else {
            setCompetitorNameOptions([]);
        }


    };


    function handleSearch() {
        console.log('Search Button clicked!');
        console.log('Category Id Selected: ', categorySelectedOptions.value);
        console.log('Session Id Selected: ', sessionSelectedOptions.value);
        console.log('Section Id Selected: ', sectionSelectedOptions.value);


    }


    async function handleRankOptionsChange(event, rowIndex, key) {
        // Update selected option state
        setRankSelectedOption(event.target.value);
        console.log("Rank  Options Change Value: ", event.target.value)
        console.log("Rank  Options Change Row Index: ", rowIndex)
        console.log("Rank  Options Change Row Key: ", key)

        const newRank = event.target.value
        const participatesInModel = key
        if (newRank) {

            try {

                // const competitor = await competitorRepository.getCompetitorById('040b00fd-b5a0-489a-abb2-fa0637dcf52d');
                const participateUpdateData = await participatesInRepository.updateParticipatesInRank(participatesInModel.participatesInId, newRank);

                console.log("ParticipateUpdateData New: ", participateUpdateData)

                // Update table data array with new selected value
                const newCompetitionData = [...competitionData];
                newCompetitionData[rowIndex].rank = event.target.value;
                setCompetitionData(newCompetitionData);



            } catch (error) {
                console.error("ParticipateUpdateData Error:", error);
            }
        }



    }

    function handleOrderNumberUpdateSubmit(event) {
        // Prevent default form submit behavior
        event.preventDefault();

        // Make API call to update database with new table data
        // fetch('https://example.com/api/updateTableData', {
        //     method: 'PUT',
        //     body: JSON.stringify(tableData),
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        // })
        //     .then(response => response.json())
        //     .then(data => console.log(data))
        //     .catch(error => console.error(error));
    }




    useEffect(() => {

        setRankOptions(['', '1', '2', '3', '4', '5']);


        const headers = new Headers();
        headers.append('Authorization', `Bearer ${Constants.TOKEN}`,);
        // headers.append('Access-Control-Allow-Origin', '*',);


        //Start Section Select Options
        var categoryListUrl = Constants.API_ENDPOINT + Constants.ENDPOINT_ITEMS_CATEGORY
        var fetchCategoryOptions = async () => {
            try {
                const response = await fetch(categoryListUrl, { headers });
                const data = await response.json();
                setCategoryOptions(data.data);
            }
            catch (error) {
                console.log(error);
            }
        };

        var sessionListUrl = Constants.API_ENDPOINT + Constants.ENDPOINT_ITEMS_SESSION + '?filter=' + JSON.stringify(Constants.STATUS_PUBLISHED_JSON_OBJECT)

        const fetchSessionOptions = async () => {
            const response = await fetch(sessionListUrl, { headers });
            const data = await response.json();
            setSessionOptions(data.data);
        };

        const sectionInputValue = "";
        let sectionListFilterString;
        if (sectionInputValue) {
            sectionListFilterString = JSON.stringify({
                "_and": [
                    { "status": { "_eq": "published" } },
                    {
                        "_or": [
                            { "section_desc": { "_contains": sectionInputValue } },
                            { "section_code": { "_contains": sectionInputValue } }
                        ]
                    }
                ]
            });
        } else {
            sectionListFilterString = JSON.stringify({
                "_and": [
                    { "status": { "_eq": "published" } }
                ]
            });
        }

        var sectionListUrl = Constants.API_ENDPOINT + Constants.ENDPOINT_ITEMS_SECTION + '?sort=' + Constants.SECTION_DESC + '&?filter=' + sectionListFilterString
        console.log("section list url:", sectionListUrl)

        const fetchSectionOptions = async () => {
            // const sectionResponse = await sectionRepository.getAllSectionsWithFilter('');

            // const response = await fetch(sectionListUrl, { headers });
            // const data = await response.json();
            // setSectionOptions(data.data);


            // console.log("Section Response", data)


            try {

                // const competitor = await competitorRepository.getCompetitorById('040b00fd-b5a0-489a-abb2-fa0637dcf52d');
                const sectionData = await sectionRepository.getAllSectionsWithFilter('');

                console.log("Section Data New: ", sectionData)
                const newOptions = sectionData.map(item => ({
                    value: item.sectionId,
                    label: item.sectionCode + ' ' + item.sectionDesc,
                }));
                setSectionOptions(newOptions);


            } catch (error) {
                console.error("Section Repository Error:", error);
                setSectionOptions([])
            }

            // setSectionOptions(data.data);
        };






        // fetchCategoryOptions();
        // fetchSessionOptions()
        fetchSectionOptions()

        //End Section Select Options

        //Start Competitor Option

        //Start Competition URL Filter Check

        // var competitionUrlfilter = {
        //     "competition_date": { "_between": [competitionStartDate, competitionEndDate] },
        //     "competitor": { "competitor_id": { "_eq": competitorFirstNameSelectedOptions.value } },
        //     "section": {
        //         "section_id": { "_eq": sectionSelectedOptions.value },
        //         "category_session": {
        //             "session": { "session_id": { "_eq": sessionSelectedOptions.value } },
        //             "category": { "category_id": { "_eq": categorySelectedOptions.value } }
        //         }
        //     }
        // }

        var competitionUrlfilter = {}
        if (competitorNameSelectedOptions.value) {
            competitionUrlfilter.competitor = { "competitor_id": { "_eq": competitorNameSelectedOptions.value } };
        }
        if (competitorNameSelectedOptions.value || sessionSelectedOptions.value || categorySelectedOptions.value) {
            var sectionFilter = {}
            if (sectionSelectedOptions.value) {
                sectionFilter.section_id = { "_eq": sectionSelectedOptions.value }
            }
            if (sessionSelectedOptions.value || categorySelectedOptions.value) {

                var categorySessionFilter = {}

                if (categorySelectedOptions.value && sessionSelectedOptions.value) {
                    if (categorySessionId) {
                        categorySessionFilter.category_session_id = { "_eq": categorySessionId }
                    }

                }
                else {
                    if (sessionSelectedOptions.value) {
                        categorySessionFilter.session = { "session_id": { "_eq": sessionSelectedOptions.value } }
                    }
                    if (categorySelectedOptions.value) {
                        categorySessionFilter.category = { "category_id": { "_eq": categorySelectedOptions.value } }
                    }
                }
                sectionFilter.category_session = categorySessionFilter

                competitionUrlfilter.section = sectionFilter
            }

        }


        //End Competition URL Filter Check




        console.log("Static Competition URL Filter", JSON.stringify(competitionUrlfilter))
        console.log("Dynamic Competition URL Filter", JSON.stringify(competitionTableFilter))



        var competitionUrlToFetch = Constants.API_ENDPOINT + Constants.ENDPOINT_ITEMS_COMPETITION + Constants.COMPEITION_FIELDS + '&meta=filter_count' + '&page=' + page + '&limit=' + pageLimit + '&filter=' + JSON.stringify(competitionUrlfilter)



        console.log(competitionUrlToFetch)

        async function testApiCall() {
            try {

                // const testApiCallResponse = await sectionRepository.getSectionById('6f73b053-7681-4071-9b45-9f7ff15e4eb4');
                const testApiCallResponse = await sectionRepository.getAllSectionsWithFilter('');


                // const testApiCallResponse = await participatesInRepository.getAllParticipatesInWithFilter('2021-01-24', '2024-01-24', null, null, page, pageLimit)

                console.log("Test Api Call Data", testApiCallResponse)
            } catch (error) {
                console.error("Test Api Call Data Error:", error);
            }
        }

        // testApiCall()


        async function fetchParticipations() {
            try {

                // const competitor = await participatesInRepository.getParticipatesInById('e0555655-b56e-427f-af17-cb1cf70dcb76');

                const participatesInData = await participatesInRepository.getAllParticipatesInWithFilter('2021-01-24', '2024-01-24', null, null, page, pageLimit)
                const totalCount = participatesInData.filterCount
                const totalPages = totalCount / pageLimit
                setTotalPages(totalPages);

                setCompetitionData(participatesInData.participatesInDataModel)

                console.log("Particiaptes Data in react", participatesInData)
            } catch (error) {
                console.error("Particiaptes Data Error:", error);
            }
        }

        fetchParticipations()


        const fetchCompetitionData = async () => {
            try {
                setIsError(false)
                const response = await fetch(competitionUrlToFetch, { headers });
                const jsonData = await response.json();
                console.log(jsonData)
                if (response.ok) {
                    if (jsonData.data.length > 0) {
                        setCompetitionData(jsonData.data);
                        const totalCount = jsonData.meta.filter_count
                        const totalPages = totalCount / pageLimit
                        setTotalPages(totalPages);
                    }
                    else {
                        setIsError(true)
                        setErrorMessage('No data found')
                    }

                }
                else {
                    console.error("Something went wrong")
                    setIsError(true)
                    setErrorMessage('Something went wrong')
                }
            }
            catch (error) {
                setIsError(true)
                setErrorMessage('Something went wrong')
                console.error(error)
            }
        };

        // fetchCompetitionData();
        setCompetitionTableFilter(false)


        //End Competitor Option




    }, [page, pageLimit, competitionTableFilter]);

    const handlePageChange = newPage => {
        setPage(newPage);
    };

    const handlePageLimitChange = newPageLimit => {
        setPage(1);
        setPageLimit(newPageLimit);
    };

    const handleCompetitorNameClicked = (competitorId) => {
        console.log("Name clicked", competitorId)
        navigate(`/update/competitor/${competitorId}`);
    };




    const sendEmail = (id) => {
        console.log("Sending Please wait...")
        setSendingEmail(true)
        // fetch(`https://jsonplaceholder.typicode.com/posts/${id}`, {
        //     method: "DELETE",
        // }).then(() => {
        //     setPosts(posts.filter((post) => post.id !== id));
        // });
    };

    const printCertificate = (participation) => {
        setIsPrinting(true)
        // const certificateData = { 'name': 'Samit', 'date': '2022/03/03' }
        const competitorName=participation.competitor.competitorFirstName
        const certificateData=new Certificate(competitorName,'awarded for','2022/03/03')

        const pdfUrl = certificateRepository.createCertificate(certificateData)
        console.log("Printing Certificate Please wait...", pdfUrl)
        setIsPrinting(false)

        // fetch(`https://jsonplaceholder.typicode.com/posts/${id}`, {
        //     method: "DELETE",
        // }).then(() => {
        //     setPosts(posts.filter((post) => post.id !== id));
        // });

        // window.print();

        // if (pdfUrl) {
        //     window.open(pdfUrl, "_blank");
        // }

        

    };




    return (
        <div>
            <h2>Participations</h2>
            <div>

                {/* Start Date Select */}

                {/* <div className="date-range-picker">
                    <div className="date-range-picker__inputs-wrapper">
                        <label className="date-range-picker__label">
                            Start Date:
                            <input
                                type="date"
                                value={startDate}
                                onChange={handleStartDateChange}
                                className="date-range-picker__input"
                            />
                        </label>
                        <label className="date-range-picker__label">
                            End Date:
                            <input
                                type="date"
                                value={endDate}
                                onChange={handleEndDateChange}
                                className="date-range-picker__input"
                            />
                        </label>
                    </div>
                    <p className="date-range-picker__selected-date-range">
                        Selected Date Range: {startDate} - {endDate}
                    </p>
                </div> */}

                {/* End Date Select */}

                {/* Start Date Range Picker */}
                <div className="date-range-picker">


                    <button onClick={handleDateRangeButtonClick}>Select Date</button>

                    {showPicker && (

                        <DateRangePicker
                            ranges={[dateRange]}
                            onChange={handleDateRangeChange}
                        />

                    )}

                    <button onClick={handleDateRangeDoneClick}>Done</button>

                    <p className="date-range-picker__selected-date-range">
                        Selected Date Range: {startDate} - {endDate}
                    </p>

                </div>


                {/* End Date Range Pciker */}




                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '50px' }}>




                        {/* <Select placeholder="Category" value={categorySelectedOptions} options={categoryOptions.map(item => ({ label: item.category_name, value: item.category_id }))} onChange={handleCategorySelectChange} />
                        <Select placeholder="Session" value={sessionSelectedOptions} options={sessionOptions.map(item => ({ label: item.session_name, value: item.session_id }))} onChange={handleSessionSelectChange} /> */}
                        {/* <Select placeholder="Section" value={sectionSelectedOptions} options={sectionOptions.map(item => ({ label: item.sectionDesc, value: item.sectionId }))} onChange={handleSectionSelectChange} /> */}

                        {/* <Select placeholder="Category Test"
                          inputValue={inputValue}
                          onInputChange={handleInputChange}
                         value={categorySelectedOptions} options={categoryOptions.map(item => ({ label: item.category_name, value: item.category_id }))} onChange={handleCategorySelectChange} /> */}

                        <Select
                            placeholder="Section"
                            inputValue={sectionInputValue}
                            onInputChange={handleSectionSelectChange}
                            options={sectionOptions}
                            onChange={handleSectionSelectedOptions}
                            styles={{

                                control: (provided, state) => ({
                                    ...provided,
                                    width: 300,
                                }),
                            }}
                        />


                        <Select
                            placeholder="Name"
                            inputValue={nameInputValue}
                            onInputChange={handleNameChange}
                            options={competitorNameOptions}
                            onChange={handleCompetitorsNameSelectedOptions}
                            styles={{
                                dropdownIndicator: (provided, state) => ({
                                    ...provided,
                                    display: 'none',
                                }),
                                control: (provided, state) => ({
                                    ...provided,
                                    width: 200,
                                }),
                            }}
                        />

                        {/* <button onClick={handleSearchClear}>Clear Filter</button> */}




                    </div>
                </div>


                <div style={{ margin: '15px', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '50px' }}>
                        {/* <Select placeholder="First Name"  defaultOptions={false}
                            value={competitorFirstNameSelectedOptions} options={competitorFirstNameOptions.map(item => ({ label: item.competitor_first_name, value: item.competitor_id }))} onChange={handleCompetitorFirstNameSelectChange} /> */}

                        {/* <Select placeholder="Category Test"
                          inputValue={inputValue}
                          onInputChange={handleInputChange}
                         value={categorySelectedOptions} options={categoryOptions.map(item => ({ label: item.category_name, value: item.category_id }))} onChange={handleCategorySelectChange} /> */}

                        {/* <Select
                            placeholder="First Name"
                            inputValue={firstNameInputValue}
                            onInputChange={handleFirstNameChange}
                            options={competitorFirstNameOptions}
                            onChange={handleCompetitorsFirstNameSelectedOptions}
                            styles={{
                                dropdownIndicator: (provided, state) => ({
                                    ...provided,
                                    display: 'none',
                                }),
                                control: (provided, state) => ({
                                    ...provided,
                                    width: 200,
                                }),
                            }}
                        /> */}
                        {/* <button onClick={handleSearchClear}>Clear Filter</button> */}





                    </div>




                </div>




            </div>

            <div>

                <br></br>
                <br></br>


            </div>



            {/* <div>
                <button className="search-button" onClick={handleSearch}>
                    Search
                </button>

            </div> */}

            <div>

                {/* <table {...getTableProps()}>
                    <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {rows.map(row => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map(cell => (
                                        <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                    ))}
                                </tr>
                            );
                        })}
                    </tbody>
                </table> */}
            </div>

            <div >



                <table className="table">
                    <thead>
                        <tr>
                            <th>S. No.</th>
                            <th>Competition Date</th>
                            <th>Competition Status</th>

                            <th>Section</th>
                            <th>Section Desc</th>

                            <th>Competitor Name</th>
                            <th>Order</th>
                            <th>Rank</th>
                            <th>Actions</th>


                        </tr>
                    </thead>

                    {isError ? (
                        <tbody>
                            <tr >
                                <td>{errorMessage}</td>
                                <td>Please try again later.</td>
                            </tr >
                        </tbody>

                    ) : (

                        <tbody>
                            {competitionData.map((participation, index) => (
                                <tr key={participation.participatesInId}>
                                    <td>{index + 1}</td>
                                    <td>{participation.competition.competitionDate}</td>
                                    <td>{participation.competition.competitionStatus}</td>

                                    <td>{participation.competition.section.sectionCode}</td>
                                    <td>{participation.competition.section.sectionDesc}</td>
                                    <td className="highlight-column" onClick={() => handleCompetitorNameClicked(participation.competitor.competitorId)}>
                                        {participation.competitor.competitorFirstName}
                                        {' '}
                                        {participation.competitor.competitorLastName}
                                    </td>
                                    <td>{participation.orderNo}</td>

                                    {/* style={{ padding: '0 10px' }} */}

                                    <td>
                                        {participation.rank}


                                        <select style={{ margin: '0 10px' }}
                                            // value={rankSelectedOption}
                                            onChange={event => handleRankOptionsChange(event, index, participation)}>
                                            {rankOptions.map(option => (
                                                <option key={option} value={option}>
                                                    {option}
                                                </option>
                                            ))}
                                        </select>



                                    </td>

                                    <td>
                                        {/* <button className="delete-button" disabled={sendingEmail}
                                            onClick={() => sendEmail(participation.participatesInId)}>Email</button> */}

                                        <button className="delete-button" disabled={isPrinting}
                                            onClick={() => printCertificate(participation)}>Print</button>





                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    )}
                </table>
            </div>

            <div>
                <button disabled={page === 1} onClick={() => handlePageChange(page - 1)}>
                    Previous
                </button>
                {Array.from({ length: totalPages }).map((_, index) => (
                    <button key={index} onClick={() => handlePageChange(index + 1)} disabled={page === index + 1}>
                        {index + 1}
                    </button>
                ))}
                <button disabled={page === totalPages} onClick={() => handlePageChange(page + 1)}>
                    Next
                </button>
                <select value={pageLimit} onChange={event => handlePageLimitChange(parseInt(event.target.value, 10))}>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                </select>
            </div>


        </div>
    );
}

export default Competition;
